import { render, staticRenderFns } from "./FeedList.vue?vue&type=template&id=8ada1874&scoped=true&"
import script from "./FeedList.vue?vue&type=script&lang=js&"
export * from "./FeedList.vue?vue&type=script&lang=js&"
import style0 from "./FeedList.vue?vue&type=style&index=0&id=8ada1874&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ada1874",
  null
  
)

export default component.exports